import gql from 'graphql-tag';
import { GetAdmission, admissionsResultFields } from '../queries/westerosAdmissionsQueries';

export interface UpsertAdmissionMutationInput {
  courseId?: number;
  campusId?: number;
}

export interface UpsertAdmission extends GetAdmission {}

export interface UpsertAdmissionMutationResult {
  upsertAdmission: UpsertAdmission;
}

export const upsertAdmission = gql`
  mutation upsertAdmission($data: UpsertAdmissionMutationInput!) {
    upsertAdmission(data: $data) {
      ${admissionsResultFields}
    }
  }
`;
